export default "__VITE_ASSET__IhGm_td___"